import React, { useState, useEffect, useRef } from 'react';
import "../Header/header.scss";
import { Image_Url } from '../../../constants/imageUrl/ImageUrl';
import { useNavigate } from 'react-router-dom';
import { logoutAction } from '../../../actions/logoutAction';
import { useDispatch } from "react-redux";
import { notify } from '../../../services/notification';
import { clearUserAuthCookies } from '../../../utils/authCookies';
import LogoutButton from './LogoutButton';

const Header = (props) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);  // New ref for dropdown
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // New useEffect for handling clicks outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        // Add event listener when dropdown is shown
        if (showDropdown) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        // Cleanup function
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showDropdown]);

    const handleLogout = async () => {
        const response = await dispatch(logoutAction());
        if (response?.data?.success === true) {
            clearUserAuthCookies();
            notify.success(response?.data?.message);
            navigate("/");
            window.location.reload();
        } else {
            notify.error(response?.data?.message || "Logout failed");
        }
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    return (
        <div className="PgmlistTextHeadings">
            <div className="pgm_listtexts capitalize-text">{props.title}</div>
            <div className="logout" ref={dropdownRef}>  {/* Added ref here */}
                {/* <img 
                    className="Header_Image" 
                    src={Image_Url.TVSADMIN1} 
                    onClick={toggleDropdown}
                    alt="admin"
                /> */}
                {/* {showDropdown && ( */}
                {/* <div className="dropdown-headers"> */}
                {/* <span className='span-logout-text cursor_pointer' onClick={handleLogout}>
                            <img src={Image_Url.LOGOUT} className="logout-images" alt="logout"/>
                            Logout
                        </span> */}
                <LogoutButton handleLogout={handleLogout} />
                {/* </div> */}
                {/* )} */}
            </div>
        </div>
    );
};

export default Header;